import { Injectable } from '@angular/core';
import countries from '../../assets/i18n/countires.json';

@Injectable({
  providedIn: 'root',
})
export class CountriesService {
  getCountryPrefixList(): Country[] {
    const country_prefixes: Country[] = [];
    countries.forEach(c => {
      country_prefixes.push({
        name: c.name,
        code: c.code,
        flag: `../../assets/img/flags/${c.code}.svg`,
        prefix: c.dial_code,
      });
    });
    return country_prefixes;
  }
}

export interface Country {
  name: string;
  code: string;
  prefix: string;
  flag: string;
}
